module.exports = __webpack_public_path__ + "img/picto-ferme.e069b371.svg";